import { useContext, useEffect } from 'react';
import { AppHeaderLeadContext } from '../contexts/app-header-lead';

/**
 * Register content beside the page title in AppHeader (e.g. detail ID, status).
 */
export function useAppHeaderLead(factory, deps) {
  const { setLead, clearLead } = useContext(AppHeaderLeadContext);

  useEffect(() => {
    setLead(factory());
    return () => clearLead();
  }, deps);
}
